import { getStoryBySlug } from "../story/requests";
import {Homepage} from "./entities";

const getHomepage = () => getStoryBySlug("/").then(Homepage)

export { getHomepage };
